import './ButtonStripe.css'

import React from 'react'

const ButtonStripe: React.FC = ({ children }) => (
  <div className="button__stripe">
    <div className="button__stripe__bar" />
    <div className="button__stripe__button">{children}</div>
  </div>
)

export default ButtonStripe
